export default function useUrlWithHost(url: string) {
  if (url.includes('http')) return url;

  return `https://${url}`;
}
